import { MdNewspaper } from "react-icons/md";
import { AiOutlineGithub } from "react-icons/ai";
import { CiInstagram } from "react-icons/ci";
import { MdFacebook } from "react-icons/md";
import { FaHome } from "react-icons/fa";
import { PiSoccerBallFill } from "react-icons/pi";



export const menuText = [
    {
        title: "축구 유튜버 홈",
        icon: <FaHome />,
        src: "/"
    }, {
        title: "오늘의 추천 픽!!",
        icon: <MdNewspaper />,
        src: "/today"
    }, {
        title: "축구 유튜버 소개",
        icon: <PiSoccerBallFill />,
        src: "/youtuber"
    }
]

export const keywordText = [
    {
        title: "이스타 TV",
        src: "/search/이스타 TV"
    },
    {
        title: "달수네라이브",
        src: "/search/달수네라이브"
    },
    {
        title: "슛포러브",
        src: "/search/슛포러브"
    },
    {
        title: "이거해조 원희형",
        src: "/search/이거해조 원희형"
    },
    {
        title: "고알레GOALE",
        src: "/search/고알레GOALE"
    },
    {
        title: "김진짜 RealKIM",
        src: "/search/김진짜 RealKIM"
    },
    {
        title: "말년 호빙요",
        src: "/search/말년 호빙요"
    },
    {
        title: "새벽의 축구 전문가",
        src: "/search/새벽의 축구 전문가"
    },
    {
        title: "JK 아트사커 온라인",
        src: "/search/JK 아트사커 온라인"
    },
    {
        title: "축구 읽어주는 여자 쵱내",
        src: "/search/축구 읽어주는 여자 쵱내"
    },
    {
        title: "K LEAGUE",
        src: "/search/K LEAGUE"
    },
    {
        title: "KFATV",
        src: "/search/KFATV"
    },
    {
        title: "Tottenham Hotspur",
        src: "/search/Tottenham Hotspur"
    },
    {
        title: "오늘의 K리그",
        src: "/search/오늘의 K리그"
    },
    {
        title: "불양TV",
        src: "/search/불양TV"
    },
    {
        title: "안정환 19",
        src: "/search/안정환 19"
    },
]


export const snsText = [
    {
        title: "github",
        src: "https://github.com/jinhomun",
        icon: <AiOutlineGithub />
    }, {
        title: "Instagram",
        src: "https://www.instagram.com/jinho_m01/",
        icon: <CiInstagram />
    }, {
        title: "Facebook",
        src: "https://www.facebook.com/profile.php?id=100008125899652&locale=ko_KR",
        icon: <MdFacebook />
    }
]